import { startPeriodicServiceWorkerUpdateChecks } from './serviceWorkerUpdateCheck';

export function register() {
  if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) {
    return;
  }

  const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
  if (publicUrl.origin !== window.location.origin) {
    return;
  }

  window.addEventListener('load', () => {
    registerValidSW(`${process.env.PUBLIC_URL}/service-worker.js`);
  });
}

function registerValidSW(swUrl: string) {
  navigator.serviceWorker
    .register(swUrl, {
      updateViaCache: 'none',
    })
    .then(() => {
      startPeriodicServiceWorkerUpdateChecks();
    })
    .catch(() => undefined);
}
